// extracted by mini-css-extract-plugin
export default {"rangeFields":"BuildingSize_rangeFields__kO51W","rangeField":"BuildingSize_rangeField__yguRy","dashMark":"BuildingSize_dashMark__UakcN"};